import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { CogIcon } from '@rsos/assets/icons';
import { Button, Absolute } from '@rsos/components/capstone/base';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import {
  DropdownDialog,
  DropdownBody,
  DropdownList,
  DropdownListItem,
} from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { ACCEPTED, OUTBOUND } from '../utils';
import EditPairModal from './EditPairModal/index';
import RemovePairModal from './RemovePairModal/index';

const SettingsControl = ({ authority, type }) => {
  const agencyLinks = useSelector(state => state.alertsRouting.agencyLinks);

  const { shareableAlertEmergencyTypes } = agencyLinks;

  const [isRemovePairModalOpened, setIsRemovePairModalOpened] = useState(false);
  const [isEditPairModalOpened, setIsEditPairModalOpened] = useState(false);

  const handleEditPair = () => {
    setIsEditPairModalOpened(true);
  };
  const handleRemovePair = () => {
    setIsRemovePairModalOpened(true);
  };
  const handleCloseRemovePairModal = () => {
    setIsRemovePairModalOpened(false);
  };
  const handleCloseEditPairModal = () => {
    setIsEditPairModalOpened(false);
  };

  return (
    <>
      <Dropdown triggerElement={CogMenu} triggerOnClose>
        {onDropdownClose => (
          <Absolute top={35} left={6} zIndex={1}>
            <DropdownDialog width="164px">
              <DropdownBody>
                <DropdownList borderless>
                  <DropdownListItem
                    disabled={authority.status !== ACCEPTED}
                    onClick={() => handleEditPair(onDropdownClose)}
                  >
                    Edit
                  </DropdownListItem>

                  <DropdownListItem
                    onClick={() => handleRemovePair(onDropdownClose)}
                  >
                    Remove pair
                  </DropdownListItem>
                </DropdownList>
              </DropdownBody>
            </DropdownDialog>
          </Absolute>
        )}
      </Dropdown>
      <RemovePairModal
        isOpened={isRemovePairModalOpened}
        onClose={handleCloseRemovePairModal}
        authority={authority}
        type={type}
      />
      <EditPairModal
        isOpened={isEditPairModalOpened}
        onClose={handleCloseEditPairModal}
        authority={authority}
        type={type}
        alertTypes={
          type === OUTBOUND
            ? shareableAlertEmergencyTypes
            : authority?.attributes?.alert_emergency_types
        }
      />
    </>
  );
};

export default SettingsControl;

export function CogMenu({ selected, onClick }) {
  return (
    <Button
      btnType="tertiary"
      size="xxsmall"
      onClick={onClick}
      selected={selected}
      type="button"
      noMargin
      px="5px"
    >
      <CogIcon width={14} height={14} color="secondaryLink" />
    </Button>
  );
}
